/* eslint-disable react/prop-types */
/* global FB */
import { useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'

import AccountSelectionPage from '../AccountSelectionPage'
import { SignInAnimation } from '../../components/SignInAnimation'

import 'react-toastify/dist/ReactToastify.css'

import {
  ArrowRigth,
  BoxChecket,
  BoxNotChecket,
  Eye,
  GoogleColorIcon,
  LockClosed,
  LockClosedCampaignIcon,
  LockClosedIcon,
  LockClosedOutlineCustom,
  LockIcon,
} from '../../assets/svgs/icons'

import {
  ArtStatusService,
  Login,
  UserAccountsService,
  UserService,
} from '../../services/index'

import { useAuth } from '../../hooks/useAuth'

import Loading from '../../components/Loading'

import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { notifyErrorCustom } from '../../utils/notify'
import DefaulterPage from '../DefaulterPage'
import { useGoogleLogin } from '@react-oauth/google'
import { LuMail } from 'react-icons/lu'
import { PiEyeClosed } from 'react-icons/pi'
import LanguageSwitcher from '../../components/languageSwitcher'

function SignIn() {
  const { login } = useAuth()
  const navigation = useNavigate()
  const { t } = useTranslation()
  const googleLogin = useGoogleLogin({
    scope: 'openid profile email',
    onSuccess: async ({ access_token: accessToken }) => {
      if (!accessToken) {
        notifyErrorCustom(t('signin_google_error'))
        return
      }

      setButtonLoading(true)

      try {
        const googleLoginData = await Login.postAuthRegisterGoogle({
          credential: accessToken,
          idToken: accessToken,
          token: accessToken,
        })

        if (googleLoginData?.responseStatus !== 200) {
          setButtonLoading(false)
          setLoading(false)
          throw new Error(t('signin_google_error'))
        }
        const googleSession = googleLoginData?.data?.data || googleLoginData?.data || {}
        const googleSessionToken =
          googleSession?.token ||
          googleSession?.access_token ||
          googleSession?.accessToken ||
          accessToken

        const sessionToPersist = {
          ...googleSession,
          token: googleSessionToken,
        }

        // Ensure services that read token from localStorage use the Google token
        try {
          window.localStorage.setItem('token', JSON.stringify(googleSessionToken))
        } catch (e) {
          console.warn('Could not set token in localStorage', e)
        }

        const userAccount =
          sessionToPersist?.user?.UserAccount?.[0] ||
          sessionToPersist?.userAccount?.[0] ||
          sessionToPersist?.UserAccount?.[0] ||
          null

        if (userAccount && userAccount.token !== googleSessionToken) {
          const userAccountToUpdate = { ...userAccount }

          delete userAccountToUpdate.uuid
          delete userAccountToUpdate.createdAt
          delete userAccountToUpdate.updatedAt
          delete userAccountToUpdate.deletedAt
          delete userAccountToUpdate.photoName
          delete userAccountToUpdate.photoUrl
          delete userAccountToUpdate.freePlanChose
          delete userAccountToUpdate.state
          delete userAccountToUpdate.userMissionStatus

          userAccountToUpdate.lastLogin = new Date()
          userAccountToUpdate.token = googleSessionToken

          await UserAccountsService.putUserAccountsByLogin(userAccountToUpdate)
        }

        // Use AuthProvider.login so context is populated and navigation is consistent
        try {
          await login(sessionToPersist, '/ChatSocket')
        } catch (err) {
          // fallback to previous behavior
          window.localStorage.setItem('userData', JSON.stringify(sessionToPersist))
          window.localStorage.setItem('token', JSON.stringify(googleSessionToken))
          navigation('/ChatSocket')
        }
      } catch (error) {
        console.error('error googleLogin', error)
        notifyErrorCustom(t('signin_google_error'))
        setButtonLoading(false)
        setLoading(false)
      }
    },
    onError: () => {
      notifyErrorCustom(t('signin_login_error'))
    },
  })

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const [loading, setLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [showPasswordStep, setShowPasswordStep] = useState(false)
  const [useGoogleAuth, setUseGoogleAuth] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [rememberMe, setRememberMe] = useState(false)

  const [usersTologin, setUsersToLogin] = useState(false)

  const [bodyLoginUser, setBodyLoginUser] = useState(false)

  const [userDefaulter, setUserDefaulter] = useState([])

  const [guestUser, setGuestUser] = useState(false)
  const emailInputRef = useRef(null)

  const initFacebookSDK = () => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '387543906967686',
        cookie: true,
        xfbml: true,
        version: 'v18.0',
      })

      FB.AppEvents.logPageView()
    }
    ; (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }

  useEffect(() => {
    initFacebookSDK()
  }, [])

  useEffect(() => { }, [userDefaulter])

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
    if (showPasswordStep || useGoogleAuth) {
      setShowPasswordStep(false)
      setUseGoogleAuth(false)
      setPassword('')
      setShowPassword(false)
    }
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value)
  }

  const handleCreateAccount = () => {
    navigation('/Register')
  }

  const handleChecked = () => {
    setRememberMe((current) => !current)
  }

  const checkFields = () => {
    if (email === '') {
      notifyErrorCustom(t('signin_error_email'))
      return false
    }

    if (password === '') {
      notifyErrorCustom(t('signin_error_password'))
      return false
    }

    if (password.length < 8) {
      notifyErrorCustom(t('signin_error_password_and_user'))
      return false
    }

    return true
  }

  const handleContinue = async (event) => {
    event.preventDefault()

    if (email === '') {
      notifyErrorCustom(t('signin_error_email'))
      return
    }

    setButtonLoading(true)

    try {
      const checkEmail = await UserService.getUserCheckEmailExists(email)
      const hasGoogleId = checkEmail?.data?.hasGoogleId === true

      if (hasGoogleId) {
        setUseGoogleAuth(true)
        return
      }

      setUseGoogleAuth(false)
      setShowPasswordStep(true)
    } catch (error) {
      console.error('error checking email login method', error)
      setUseGoogleAuth(false)
      setShowPasswordStep(true)
    } finally {
      setButtonLoading(false)
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)
    handleLogin()
  }

  const handleLogin = async () => {
    if (!checkFields()) {
      setLoading(false)
      return
    }

    let body = {
      email: email,
      password: password,
    }

    const checkUsers = await Login.postCheckUser(body)

    if (
      checkUsers?.data?.isDefaulter &&
      checkUsers.data.userBusiness.length <= 0
    ) {
      const userDefaulter = {
        userDefaulter: checkUsers.data.user,
        guestUser: false,
      }
      setUserDefaulter(userDefaulter)
      setGuestUser(false)
      setLoading(false)

      return
    }

    if (
      ((checkUsers?.data?.user != null &&
        checkUsers?.data?.userBusiness?.length > 0) ||
        checkUsers?.data?.userBusiness?.length > 1) &&
      checkUsers.data.passwordOk
    ) {
      await setUsersToLogin(checkUsers)
      await setBodyLoginUser(body)
      setLoading(false)
      return
    }

    if (
      !checkUsers?.data?.user &&
      checkUsers?.data?.userBusiness?.length == 1 &&
      checkUsers?.data?.passwordOk
    ) {
      const uuid = checkUsers.data.userBusiness[0].uuid
      const bodyToLogin = { ...body, uuid }
      let loginGuestData = await Login.postGuestComparePassword(bodyToLogin)
      if (loginGuestData?.responseStatus === 200) {
        const guestUserId = uuid
        const loginDataRet = { ...loginGuestData.data, guestUserId }
        await login(loginDataRet)

        let userAccount = checkUsers.data.user.UserAccount[0]

        if (userAccount) {
          userAccount.lastLogin = new Date()

          delete userAccount.uuid
          delete userAccount.createdAt
          delete userAccount.updatedAt
          delete userAccount.deletedAt
          delete userAccount.freePlanChose
          delete userAccount.state
          delete userAccount.photoName
          delete userAccount.photoUrl
          delete userAccount.userMissionStatus

          await UserAccountsService.putUserAccountsByLogin(userAccount)
        }

        return
      }

      setLoading(false)
      return
    }

    if (!checkUsers?.data?.passwordOk) {
      notifyErrorCustom(t('signin_error_password_and_user'))
      setLoading(false)
      return
    }

    let loginData = await Login.postAuth(body)

    if (loginData?.responseStatus === 200) {
      const loginDataRet = { ...loginData.data }

      await login(loginDataRet)
      let userAccount = checkUsers.data.user.UserAccount[0]

      if (userAccount) {
        userAccount.lastLogin = new Date()
        const artstatusbyuseraccount = await ArtStatusService.getArtStatusByUserAccount(userAccount.uuid)
        delete userAccount.uuid
        delete userAccount.createdAt
        delete userAccount.updatedAt
        delete userAccount.deletedAt
        delete userAccount.freePlanChose
        delete userAccount.state
        delete userAccount.photoName
        delete userAccount.photoUrl

        if (!artstatusbyuseraccount.data.isVisualized) {
          localStorage.setItem('pendingArtPopupShown', 'true')
        }

        await UserAccountsService.putUserAccountsByLogin(userAccount)
      }

      // const dataEvent = {
      //   event: 'user_logged_in',
      //   eventData: {},
      // }
      // await registerEvent(dataEvent)
      return
    }

    if (loginData?.response?.status === 401) {
      notifyErrorCustom(t('signin_error_password_and_user'))
    }

    setLoading(false)
  }

  const isButtonLoading = buttonLoading || loading
  const emailLocked = showPasswordStep || useGoogleAuth
  const buttonLabel = isButtonLoading ? t('signin_loading') : t('signin_continue')

  // const registerEvent = async (data) => {
  //   await EventMapService.postEventMap(data)
  // }

  return (
    <motion.div
      // key={expanded}
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ width: '100%', height: '100%', overflow: 'auto'}}
    >
      <>
        {userDefaulter.userDefaulter ? (
          <DefaulterPage userDefaulter={userDefaulter} guestUser={guestUser} />
        ) : (
          <div className={!usersTologin ? styles.page : ''}>
            <Loading enable={loading} />

            {usersTologin && (
              <AccountSelectionPage
                usersTologin={usersTologin}
                bodyLoginUser={bodyLoginUser}
              />
            )}
            {!usersTologin && (
              <div className={styles.sign_in_field}>
                <div className={styles.sign_box}>
                  <div className={styles.signInLanguageSwitcher}>
                    <LanguageSwitcher dropdown compact ghost />
                  </div>
                  <SignInAnimation />
                </div>

                {/* <div className={styles.sign_in_img_field}> */}
                <div className={styles.sign_box_login}>
                  <div className={styles.container_content}>

                    <div className={styles.sign_in_form_field}>
                      
                      <p className={styles.sign_in_form_field_login_title}>
                        {t('signin_title')}
                      </p>
                      <p className={styles.sign_in_form_field_login_subtitle}>
                        {t('signin_access_your_account')}
                      </p>

                      {!useGoogleAuth && (
                        <>
                          <button
                            className={styles.google_login_button}
                            type="button"
                            onClick={() => googleLogin()}
                            disabled={isButtonLoading}
                          >
                            <GoogleColorIcon />
                            <span>{t('signin_continue_google')}</span>
                          </button>

                          <div className={styles.login_divider}>
                            <span>{t('signin_or')}</span>
                          </div>
                        </>
                      )}

                      <form
                        className={styles.input_field}
                        onSubmit={
                          useGoogleAuth
                            ? (event) => event.preventDefault()
                            : showPasswordStep
                              ? handleSubmit
                              : handleContinue
                        }
                      >
                        <div className={styles.box_input_form}>
                          <span className={styles.box_input_form_label}>{t('register_email')}</span>
                          <div className={styles.email_input_shell}>
                            <span className={styles.email_input_icon} aria-hidden="true">
                              <LuMail size={24} color='rgba(166, 166, 178, 1)'/>
                            </span>
                            {!emailLocked ? (
                              <input
                                ref={emailInputRef}
                                className={styles.inputs}
                                type="email"
                                placeholder={t('signin_email_placeholder')}
                                value={email}
                                onChange={handleEmailChange}
                                autoComplete="email"
                              />
                            ) : (
                              <>
                                <input
                                  ref={emailInputRef}
                                  className={styles.inputs}
                                  type="email"
                                  value={email}
                                  readOnly
                                  autoComplete="email"
                                />
                                <button
                                  type="button"
                                  className={styles.email_edit_button}
                                  onClick={() => {
                                    setShowPasswordStep(false)
                                    setUseGoogleAuth(false)
                                    setPassword('')
                                    setTimeout(() => {
                                      emailInputRef.current?.focus()
                                    }, 50)
                                  }}
                                >
                                  {t('signin_edit')}
                                </button>
                              </>
                            )}
                          </div>
                        </div>

                        {showPasswordStep && !useGoogleAuth && (
                          <>
                            <div className={styles.box_input_form}>
                              <div style={{
                                display:'flex',
                                justifyContent:'space-between'
                              }}>
                                <span className={styles.box_input_form_label}>{t('register_password')}</span>
                                <p
                                  className={styles.forgot_password_link}
                                  onClick={() => navigation('/ForgotPassword')}
                                >
                                  {t('signin_lose_password')}
                                </p>

                              </div>
                              <div className={styles.password_input_shell}>
                                <span className={styles.password_input_icon} aria-hidden="true">
                                  <LockClosedOutlineCustom color="#9DA1B2" />
                                </span>
                                <input
                                  className={styles.inputs}
                                  type={showPassword ? 'text' : 'password'}
                                  placeholder={t('fast_publishing_pass_input_placeholder')}
                                  value={password}
                                  onChange={handlePasswordChange}
                                  autoComplete="current-password"
                                />
                                <button
                                  className={styles.password_toggle_button}
                                  type="button"
                                  onClick={() => setShowPassword((current) => !current)}
                                  aria-label={showPassword ? t('signin_hide_password') : t('signin_show_password')}
                                >
                                  {showPassword ? <PiEyeClosed /> : <Eye />}
                                  
                                </button>
                              </div>
                            </div>

                            <div className={styles.control_password} />
                          </>
                        )}

                        <div className={styles.box_button_submit}>
                          {useGoogleAuth ? (
                            <button
                              className={styles.google_login_button}
                              type="button"
                              onClick={() => googleLogin()}
                              disabled={isButtonLoading}
                            >
                              <GoogleColorIcon />
                              <span>{t('signin_continue_google')}</span>
                            </button>
                          ) : (
                            <button
                              className={styles.button_submit}
                              type="submit"
                              data-loading={isButtonLoading ? 'true' : 'false'}
                              disabled={isButtonLoading}
                            >
                              {isButtonLoading ? (
                                <span className={styles.button_loading_content}>
                                  <span className={styles.button_loading_spinner} />
                                  <span>{buttonLabel}</span>
                                </span>
                              ) : (
                                <div style={{
                                  display:'flex',
                                  justifyContent:'center',
                                  alignItems:'center',
                                  gap:10
                                }}>
                                  <span>
                                    {buttonLabel} 
                                  </span>
                                  <ArrowRigth size={20}/>
                                </div>
                              )}
                            </button>
                          )}
                          <div className={`${styles.sign_box_footer} ${!showPasswordStep ? styles.sign_box_footer_compact : ''}`}>
                            <p>
                        {t('signin_dont_have_an_account')}{' '}
                              <a onClick={handleCreateAccount}>
                          {t('signin_register')}
                              </a>
                            </p>
                          </div>
                        </div>
                      </form>
                 
                    </div>
                    <div className={styles.register_footer_note}>
                 
                      <p
                        style={{
                          fontSize: 11,
                          fontWeight:400,
                          textAlign: 'center',
                          color: 'rgba(116, 116, 116, 1)',
                          margin:0
                        }}
                      >
                          {t('signin_terms_continue')}{' '}
                        <a
                          href="https://xama.ai/termos-de-uso"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: 'rgba(65, 65, 65, 1)',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontWeight: 600,
                          }}
                        >
                            {t('signin_terms_2')}
                        </a>{' '}
                          {t('signin_terms_and')}{' '}
                        <a
                          href="https://xama.ai/politica-de-privacidade"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: 'rgba(65, 65, 65, 1)',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontWeight: 600,
                          }}
                        >
                            {t('signin_terms_4')}
                        </a>
                      </p>
                      {/* divider removed here - keep the 'ou' divider above the form */}
                      <div className={`${styles.single_divider2}`}>
                        <span />
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 6,
                          color: 'rgba(116, 116, 116, 1)',
                          fontSize: 11,
                          lineHeight: 1.2,
                        }}
                      >
                        <LockClosedCampaignIcon height={18} width={18}/>
                        <span
                          style={{
                            color:'rgba(116, 116, 116, 1)',
                            fontSize:11
                          }}
                        >{t('signin_data_protected')}</span>
                      </div>
                    
                    </div>
                  </div>

                  {/* <div className={styles.field_other_login}>
                <div className={styles.other_login_box}>
                  <GoogleIconLigin width={20} height={20} />
                </div>

                <div
                  className={styles.other_login_box}
                  onClick={() => SocialMediaLogin('facebook')}
                >
                  <Facebook width={20} height={20} />
                </div>

                <div className={styles.other_login_box}>
                  <Apple width={20} height={20} />
                </div>
              </div> */}
                </div>
              </div>
              // </div>
            )}
          </div>
        )}
      </>
    </motion.div>
  )
}

export default SignIn
